module.exports = __webpack_public_path__ + "static/media/gmail.7bf74b46.svg";